import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=dfe0d0d2&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=dfe0d0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe0d0d2",
  null
  
)

export default component.exports